/*
 * @Descripttion: 
 * @Author: zhanghang
 * @Date: 2022-11-28 13:53:54
 * @LastEditors: zhanghang
 * @LastEditTime: 2023-07-28 16:54:02
 */
import warnLine from './warnLine.js'
import chartNodata from './chartNodata.js'
import unitTransform from './unitTransform.js'
function install(Vue){
  Vue.use(warnLine);
  Vue.use(chartNodata);
  Vue.use(unitTransform);
}

export default install